import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import cx from "classnames";

const ButtonLink = observer(({ children, disabled, onClick, className, ...rest }) => {
  if (disabled) {
    return (
      <span className={cx("button-link", className)} {...rest}>
        {children}
      </span>
    );
  }

  return (
    <a
      className={cx("button-link", className)}
      {...rest}
      href="#"
      onClick={e => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </a>
  );
});

ButtonLink.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

ButtonLink.defaultProps = {
  disabled: false,
};

export default ButtonLink;
